<template>
  <v-dialog v-model="isActive" persistent scrollable width="700">
    <v-card>
      <v-card-title class="pa-0 shadow-1">
        <!-- <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        > -->
        <v-card-title class="font-weight-medium primary--text">
          Detalles {{ id }}
        </v-card-title>
        <!-- </v-img> -->
      </v-card-title>

      <vuescroll
        :ops="{
          bar: { background: '#bacfcec0', keepShow: true },
        }"
      >
        <v-card-text style="max-height: 600px">
          <!-- <v-text-field
                  filled
                  rounded
                  dense
                  v-model="searchAgent"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <br /> -->
          <v-data-table
            :headers="headersDetails"
            :items="detailsList"
            :items-per-page="15"
            hide-default-footer
            :options.sync="options"
            :server-items-length="totalItems"
          >
            <!-- <template v-slot:[`item.action`]="{ item }">
              <v-tooltip top color="blue-grey">
                <template v-slot:activator="{ on }">
                  <v-hover v-slot:default="{ hover }">
                    <v-btn
                      v-on="on"
                      text
                      icon
                      :color="hover ? 'accent' : 'blue-grey'"
                      @click.stop="dialogDetails(item)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </v-hover>
                </template>
                <span>Ver asistencias</span>
              </v-tooltip>
            </template> -->
          </v-data-table>
        </v-card-text>
      </vuescroll>

      <v-divider></v-divider>

      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closeDialog"
            >Cerrar</v-btn
          >
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    id: {
      type: Number,
    },
  },

  data() {
    return {
      isLoading: false,
      // For pagination
      pageCount: 0,
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      headersDetails: [
        {
          text: "Extensión",
          value: "extensions.extension",
          class: "primary--text",
          width: "20%",
          sortable: false,
        },
        {
          text: "Ingreso",
          value: "loguin",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "logout",
          value: "created_at",
          class: "primary--text",
          width: "40%",
        },
      ],
      detailsList: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.getSecondDialogDetails();
      },
      deep: true,
    },
  },

  created() {
    this.getSecondDialogDetails();
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },

    async getSecondDialogDetails() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/agents/assistance/day/${this.id}`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.detailsList = res.data.data;
          this.totalItems = res.data.total;
          this.pageCount = res.data.last_page;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
